export const companie = {
  edit: 'Editar compañía',
  customeApp: 'Personalización de la marca',
  "brandCustomization": {
    "modal": {
      "description": "",
      "title": "La personalización de la marca ha sido guardada exitosamente."
    },
    "description": {
      "color0": "Este es el color predominante en la aplicación, se utiliza para botones principales y destacar información importante.",
      "color1": "Color utilizado para dar contraste, se utiliza específicamente en iconos, títulos y textlink.",
      "color2": "Este es el color utilizado al momento que se generan alertas, errores y advertencia.",
      "color3": "Color utilizado en los Subtítulos de la aplicación",
      "color4": "Color utilizado en los textos que no tiene una relevancia considerable en la aplicación",
      "color5": "Color utilizado en la cabecera de la aplicación móvil, además de usarse en el fondo de los componentes de los indicadores",
      "color6": "Color 1",
      "color7": "Color 2",
      "color8": "Color 3"
    },
    "gps": {
      "gpsActive": "GPS Activo en la aplicación",
      "gpsRequired": "GPS Obligatorio en la aplicación",
      "digitalFence": "Cercado digital",
      "digitalFenceMts": "Rayo del cercado digital"
    },
    timeOut: 'Configura a continuación el tiempo máximo que tendrán los usuarios seleccionados como aprobadores para gestionar los planes de acción.',
  },
  time: '{{time}} horas',
  maxTime: 'Tiempo máximo',
  "snackbar": {
    "create": {
      "success": "La compañía se creó exitosamente",
      "error": "Ocurrió un error al crear la compañía"
    },
    "update": {
      "success": "La compañía se actualizó exitosamente",
      "error": "Ocurrió un error al actualizar la compañía"
    },
    "associateDivision": {
      "error": "Ocurrió un error al asociar las divisiones"
    },
    "associateZone": {
      "error": "Ocurrió un error al asociar las zonas"
    },
    "associateDivisionAndZone": {
      "error": "Ocurrió un error al asociar las zonas y las divisiones"
    }
  },
  "filter": {
    "title": "Compañías",
    "filterTitle": "FILTRAR POR",
    "inputs": {
      "search": "Buscar compañía",
      "firstSelect": "Estatus de la compañía",
      "rol": "Rol"
    }
  },
  "informationCard": {
    "create": {
      "title": "Nueva compañía"
    },
    "edit": {
      "title": "Editar compañía"
    },
    "buttons": {
      "add": "Agregar compañía",
      "cancel": "Cancelar",
      "edit": "Actualizar compañía"
    }
  }
}